import React from 'react';
import useTheme from '../../hooks/useTheme';
import './AnnouncementBanner.scss';
import { Cross } from '../../assets/icons';
import Label from '../label/Label';
import { useDispatch } from 'react-redux';
import { ANNOUNCEMENT_BANNER_CLOSE_TRIGGER } from '../../constants/maintenanceInstanceConstants';
import PropTypes from 'prop-types';

const AnnouncementBanner = ({description}) => {
	const { color, FontFace } = useTheme('LIGHT');
    const dispatch = useDispatch();
	return (
		<div
			className="banner-container"
			style={{ backgroundColor: color.background.brand_outline }}
		>
			<div className="banner-content">
				{/* <ColoredUpgrade /> */}
				{/* <Label
					label={'New Firmware Available!'}
					type={'primary'}
					fontFamily={'Inter-Bold'}
					fontSize={FontFace.font_size.medium}
					style={{ color: color.text.hyperlink }}
				/> */}
				<Label
					// label={
					// 	'Upgrade now to the latest version for improved performance and new features.'
					// }
					label={description}
					type={'primary'}
					fontFamily={'Inter'}
					fontSize={FontFace.font_size.medium}
					style={{ color: color.text.hyperlink }}
				/>
				{/* <Label
					label={'Detail'}
					type={'primary'}
					fontFamily={'Inter'}
					fontSize={FontFace.font_size.medium}
					style={{
						color: color.text.hyperlink,
						cursor: 'pointer',
						textDecoration: 'underline',
					}}
				/> */}
			</div>
			<div className="banner-cross-container">
				<Cross className="banner-cross" onClick={()=>{
                    dispatch({type:ANNOUNCEMENT_BANNER_CLOSE_TRIGGER, payload:true});
                }}/>
			</div>
		</div>
	);
};
export default AnnouncementBanner;

AnnouncementBanner.propTypes = {
	description: PropTypes.string,
};